import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import cx from 'classnames'

import * as OrgSelectors from 'modules/org/selectors'
import * as UserSelectors from 'modules/user/selectors'

import defaultAvatar from './default-avatar.png'
import './style.css'

const DynamicSchedulingCard = ({ color, name, avatarUrl, className, showEmptyValues, hideName }) => {
  const primaryColor = color || '#1159a6'

  return (
    <div className={cx('scheduling-card', className)}  style={{ borderColor: `#${primaryColor}` }}>
      <div className="scheduling-card-header">
        {showEmptyValues ? (
          <Fragment>
            <div 
              className={cx('scheduling-card-avatar', { 'empty-state' : !avatarUrl })} 
              style={{ backgroundImage: `url(${avatarUrl})` }} 
              alt="profile_photo" />
            {!hideName && <span className={cx('scheduling-card-name', { 'empty-state' : !name })}>{name}</span>}
          </Fragment>
        ) : (
          <Fragment>
            {avatarUrl ? 
              (
                <div 
                  className="scheduling-card-avatar" 
                  style={{ backgroundImage: `url(${avatarUrl})` }} 
                  alt="profile_photo" />
              ) : (
                <img src={defaultAvatar} alt="profile_photo" className="scheduling-card-avatar" />
              )}
            {!hideName && <span className="scheduling-card-name">{name || 'Chelsea Ward'}</span>}
          </Fragment>
        )}
      </div>
      <div className="scheduling-card-placeholder-container">
        <div className="scheduling-card-placeholder placeholder-1" />
        <div className="scheduling-card-placeholder placeholder-2" />
      </div>
      <div className="scheduling-card-button" style={{ backgroundColor: `#${primaryColor}` }}>
        Book meeting
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  color: OrgSelectors.getColor(state),
  name: UserSelectors.getName(state),
  avatarUrl: UserSelectors.getAvatarUrl(state),
})

export default connect(mapStateToProps)(DynamicSchedulingCard)



// WEBPACK FOOTER //
// ./src/layouts/DynamicSchedulingCard/index.js